export const SIGNUP_ONBOARDING_PATH = "/onboarding"
export const SIGNUP_ONBOARDING_APP_PATH = "/?page=billing"
export const SIGNUP_ONBOARDING_TEST_QUESTION_LIMIT = 3
export const ONBOARDING_DOCUMENT_UPLOAD_MAX_FILES = 10

/** Legacy SPA page key kept only to redirect old verification links/bookmarks. */
export const LEGACY_SIGNUP_ONBOARDING_PAGE = "kb-url-import-onboarding"
